import * as React from 'react';
import Svg, { SvgProps, Path, Rect } from 'react-native-svg';

const ScanIcon = (props: SvgProps) => <Svg
  width='65'
  height='64'
  viewBox='0 0 65 64'
  fill='none'
  {...props}
>
  <Path
    fillRule='evenodd'
    clipRule='evenodd'
    d='M46.6504 8C45.5458 8 44.6504 7.10457 44.6504 6C44.6504 4.89543 45.5458 4 46.6504 4L52.5 4C56.366 4 59.5 7.13401 59.5 11V17.9492C59.5 19.0538 58.6046 19.9492 57.5 19.9492C56.3954 19.9492 55.5 19.0538 55.5 17.9492V11C55.5 9.34315 54.1568 8 52.5 8H46.6504ZM19.9004 6C19.9004 7.10457 19.005 8 17.9004 8H11.5C9.84315 8 8.5 9.34315 8.5 11V17.9492C8.5 19.0538 7.60457 19.9492 6.5 19.9492C5.39543 19.9492 4.5 19.0538 4.5 17.9492V11C4.5 7.13401 7.63401 4 11.5 4L17.9004 4C19.005 4 19.9004 4.89543 19.9004 6ZM17.9004 55C19.005 55 19.9004 55.8954 19.9004 57C19.9004 58.1046 19.005 59 17.9004 59L11.5 59C7.63401 59 4.5 55.866 4.5 52V45.0492C4.5 43.9446 5.39543 43.0492 6.5 43.0492C7.60457 43.0492 8.5 43.9446 8.5 45.0492V52C8.5 53.6569 9.84315 55 11.5 55H17.9004ZM46.6504 59C45.5458 59 44.6504 58.1046 44.6504 57C44.6504 55.8954 45.5458 55 46.6504 55H52.5C54.1568 55 55.5 53.6569 55.5 52V45.0492C55.5 43.9446 56.3954 43.0492 57.5 43.0492C58.6046 43.0492 59.5 43.9446 59.5 45.0492V52C59.5 55.866 56.366 59 52.5 59L46.6504 59Z'
    fill='#003A70'
  />
  <Rect
    x='1.5'
    y='30'
    width='62'
    height='4'
    rx='2'
    fill='#003A70'
  />
</Svg>;

export default ScanIcon;
